import { API_URL } from "../constants.js";
import axios from 'axios';
import middleware from '../util/middleware';

var request = axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
    }
})

/**
 * Clase para ver el request de máximo de pedidos
 */
export default class MaximoPedidosRequest {
    /**
         * Llamada el endpoint de django para obtener el detalle de máximo de pedido
         * en la BD
         * @param: id_drive. Id del drive seleccionado
         * @return: Una lista de artículos
         */
    static ListarArticulosMaximo(id_drives) {
        return middleware.hasAuth(() => request.get(`api/maximo-pedido/`, {
            params: {
                sitio_id: id_drives?.toString()
            }
        }))
    }

    /**
     * Llamada el endpoint de django para editar un máximo de pedidos
     * @param: data. objeto con información de los artículos
     * @return: Mensaje de éxito o error.
     */
     static EditarMaximoPedidos(data) {
        return middleware.hasAuth(() => request.post(`api/maximo-pedido-guardar/`, data));
    }
}